import useIntersectionObserver from "@utils/useIntersectionObserver";
import { useState } from "react";
import * as _ from "underscore";
const fallback = require('@assets/images/fallback.png')

export default function ImageViewer (props) {
    const [src, setSrc] = useState()
    const videoRef = useIntersectionObserver(_.debounce((entries) => {
        const entry = entries[0]
        const target = entry.target
        if (entry.isIntersecting) {
            setSrc(target.dataset.src)
        }
    }, 10))
    
    return (
        <img
            ref={videoRef}
            style={{width: "100%", height: "100%", objectFit:"contain"}}
            data-src={props.src}
            src={src}
            onError={e => setSrc(fallback)}
        />
    )
}